import { combineReducers } from "redux";
import user from './user_reducer';
import admin from './admin_reducer';

const rootReducer = combineReducers({
    user,
    admin
});

export default rootReducer;
